import React, { useContext } from "react";
import '../HomeStyles.css'
import {HorizontalSeparator} from "../../separators/Separators";
import { useTranslation } from "react-i18next";
import { RegionSelectedContext } from "../../../contexts/RegionSelectedContext";

const ContentComponent = () => {
    const { t } = useTranslation();
    const { yearSelected } = useContext(RegionSelectedContext);

    return (
        <div id='scrollContainer' className={'homeContentContainer'}>
            <div className={'languageSelector'} />

            <div className={'scrollContainer'} id='scrollContainer'>
                <h3 className={'titleHome'}>{ t('home.presentation.title') }</h3>
                <HorizontalSeparator/>
                <p className={'homeParagraph'}>
                    { t(`home.presentation.${yearSelected.niiff ? "niif." : ""}paragraph1`) }
                </p>
                <p className={'homeParagraph'}>
                    { t(`home.presentation.${yearSelected.niiff ? "niif." : ""}paragraph2`) }
                </p>
            </div>
        </div>
    )
};

export default ContentComponent;
